var map = {
	"./Dashboard.svg": "8ae4",
	"./History.svg": "1993",
	"./InviteFriends.svg": "159bb",
	"./Logout.svg": "3a84",
	"./Notifications.svg": "3d98",
	"./Profile.svg": "9d1c",
	"./Search.svg": "8196",
	"./Settings.svg": "2ddc",
	"./Share.svg": "243b",
	"./Ticket.svg": "092c",
	"./Wallet.svg": "6fa4",
	"./add-icon.svg": "6209",
	"./arrowdown.svg": "08ef",
	"./bell.svg": "3d56",
	"./calendar.svg": "b8bd",
	"./card-digital-sign.svg": "0fa8a",
	"./change-card.svg": "8e61",
	"./chat-icon.svg": "5d65",
	"./clock.svg": "755b",
	"./closeSide.svg": "1330",
	"./closecard.svg": "a2e7",
	"./copy.svg": "8aac",
	"./delete.svg": "0d45",
	"./edit-square.svg": "fad5",
	"./edit.svg": "daf0",
	"./eye.svg": "7364",
	"./facebook.svg": "8485",
	"./fail.svg": "c845",
	"./gmail.svg": "5bde",
	"./google.svg": "d950",
	"./hidepass.svg": "96e2",
	"./info-circle.svg": "6668",
	"./info.svg": "76ed",
	"./instagram.svg": "bd6c",
	"./linkedin.svg": "9ed9",
	"./moon.svg": "0190",
	"./navsearch.svg": "c8bb",
	"./red-warn.svg": "405c",
	"./reloadcode.svg": "99e8",
	"./resp-sidebar-open.svg": "55a6",
	"./showpass.svg": "19a8",
	"./star.svg": "cc90",
	"./statistics-graph.svg": "3a4c",
	"./success.svg": "1c27",
	"./sun.svg": "3961",
	"./telegram.svg": "2b29",
	"./tik.svg": "50ca",
	"./twitter.svg": "acf9",
	"./upload.svg": "5a96",
	"./user.svg": "6aed",
	"./value-arrow.svg": "4004",
	"./warning.svg": "daa9",
	"./whatsapp.svg": "7583"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";